if (typeof ModalBox !== 'function') {
	class ModalBox extends HTMLElement {

		constructor() {

			window.inertElems = document.querySelectorAll('[data-js-inert]');

			super();
			this.o = {
				...{
					show: 10,
					frequency: 'day',
					enabled: true,
					showOnce: true,
					closeByKey: true,
					disableScroll: true,
					blockTabNavigation: false,
					openedModalBodyClass: 'modal-opened',
				}, ...JSON.parse(this.dataset.options)
			};

			if (this.o.enabled) {
				this._modalKey = `modal-${document.location.hostname}-${this.id}`;
				this._modalStorage = !localStorage.getItem(this._modalKey) ? 'empty' : JSON.parse(localStorage.getItem(this._modalKey));
				this._modalIsVisible = false;
				if (this.querySelector('[data-content]')) {
					this._modalText = this.querySelector('[data-content]').textContent;
				}

				const timeNow = new Date().getTime();
				const inBetween = Math.round((timeNow - this._modalStorage['shown']) / 1000);

				let showModal = false;

				if (this._modalStorage == 'empty'
					|| (this.o.frequency == 'day' && inBetween > 86400)
					|| (this.o.frequency == 'week' && inBetween > 604800)
					|| (this.o.frequency == 'month' && inBetween > 2419200)
					|| this._modalStorage['content'] != this._modalText
				) {
					if (this._modalText === 'state-selector') {
						let selected = this.getCookie('stateSelected');
						if (selected == "") {
							showModal = true
						}
					} else {
						showModal = true
					}
				}

				if (showModal) {
					setTimeout(() => {
						this.show();
					}, parseInt(this.o.show * 1000));
					setTimeout(() => {
						this.querySelectorAll('[data-js-close]').forEach(elm => elm.addEventListener('click', () => { this.hide(this.o.showOnce) }));
					}, 100);
				}

			} else {
				this.querySelectorAll('[data-js-close]').forEach(elm => elm.addEventListener('click', () => { this.hide(this.o.showOnce) }));
			}

			if (this.o.closeByKey) {
				document.addEventListener('keydown', e => {
					if (e.keyCode == 27) {
						if (this.classList.contains('active')) {
							this.hide(this.o.showOnce);
						}
					}
				});
			}

			if (this._modalText === 'state-selector') {
				const btn = this.querySelector('.js-state-selector');
				const stateSelector = this.querySelector('#state-selector');
				btn.addEventListener('click', (e) => {
					const stateSelected = stateSelector.value;
					if (stateSelected != "") {
						localStorage.setItem(this._modalKey, JSON.stringify({
							'shown': (new Date().getTime()),
							'content': this._modalText,
							'state': stateSelected
						}));
						this.setCookie('stateSelected', stateSelected, 30);
						this.hide();
						location.reload();
					}
				})
			}

		}

		show() {
			this._modalIsVisible = true;

			this.setAttribute('style', '');
			setTimeout(() => {
				this.classList.add('active');
				if (this.o.disableScroll) {
					document.body.classList.add(this.o.openedModalBodyClass);
				}
				if (this.o.blockTabNavigation) {
					window.inertElems.forEach(elm => {
						elm.setAttribute('inert', '');
					});
				}
			}, 10);
			setTimeout(() => {
				if (this.querySelector('[data-js-first-focus]')) {
					this.querySelector('[data-js-first-focus]').focus();
				}
			}, 250);
		}
		hide(remember = false) {
			this._modalIsVisible = false;

			this.classList.remove('active');
			document.body.classList.remove(this.o.openedModalBodyClass);
			setTimeout(() => {
				this.style.display = 'none';
			}, 500);
			if (remember && !Shopify.designMode) {
				localStorage.setItem(this._modalKey, JSON.stringify({
					'shown': (new Date().getTime()),
					'content': this._modalText
				}));
			}
			window.inertElems.forEach(elm => {
				elm.removeAttribute('inert');
			});
		}
		setCookie(cname, cvalue, exdays) {
			const d = new Date();
			d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
			let expires = "expires=" + d.toUTCString();
			document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
		}
		getCookie(cname) {
			let name = cname + "=";
			let decodedCookie = decodeURIComponent(document.cookie);
			let ca = decodedCookie.split(';');
			for (let i = 0; i < ca.length; i++) {
				let c = ca[i];
				while (c.charAt(0) == ' ') {
					c = c.substring(1);
				}
				if (c.indexOf(name) == 0) {
					return c.substring(name.length, c.length);
				}
			}
			return "";
		}

	}

	if (typeof customElements.get('modal-box') == 'undefined') {
		customElements.define('modal-box', ModalBox);
	}

	// if ( typeof customElements.get('modal-box') == 'undefined' ) {
	// 	customElements.define('modal-box', ModalBox);
	// }

	// Shopify events

	document.addEventListener('shopify:section:select', (e) => {
		if (e.target.classList.contains('mount-popup')) {
			e.target.querySelector('modal-box').style.display = 'block';
			e.target.querySelector('modal-box').show();
		}
	});
	document.addEventListener('shopify:block:select', (e) => {
		if (e.target.hasAttribute('data-modal-box')) {
			e.target.style.display = 'block';
			e.target.show();
		}
	});
	document.addEventListener('shopify:block:deselect', (e) => {
		if (e.target.hasAttribute('data-modal-box')) {
			e.target.hide();
		}
	});
	document.addEventListener('shopify:section:deselect', (e) => {
		if (e.target.classList.contains('mount-popup')) {
			e.target.querySelector('modal-box').hide();
		}
	});

}